import { CompanyInformationForm } from '../../../types/companyInformationForm'

interface GetDefaultCompanyInformationValuesProps {
  predefinedValues?: Partial<CompanyInformationForm>
  isDefaultCompanyName?: boolean
  contactEmail?: string
}

export const getDefaultCompanyInformationValues = (
  defaultCompanyInformationValuesProps?: GetDefaultCompanyInformationValuesProps,
): CompanyInformationForm => {
  const { predefinedValues, isDefaultCompanyName, contactEmail = '' } = defaultCompanyInformationValuesProps || {}

  return {
    addressLine2: predefinedValues?.addressLine2 || '',
    autoCompletedFields: predefinedValues?.autoCompletedFields,
    companyAddress: predefinedValues?.companyAddress || '',
    companyCity: predefinedValues?.companyCity || '',
    companyName: isDefaultCompanyName ? '' : predefinedValues?.companyName || '',
    companyZipCode: predefinedValues?.companyZipCode || '',
    contactEmail: predefinedValues?.contactEmail || contactEmail,
    contactFirstName: predefinedValues?.contactFirstName || '',
    contactLastName: predefinedValues?.contactLastName || '',
    contactPhone: predefinedValues?.contactPhone || '',
    isSiretPendingAssignment: predefinedValues?.isSiretPendingAssignment || false,
    isVatExempted: predefinedValues?.isVatExempted || false,
    legalStatusCustom: predefinedValues?.legalStatusCustom || '',
    legalStatusOption: predefinedValues?.legalStatusOption || undefined,
    registrationNo: predefinedValues?.registrationNo || '',
    sharedCapital: predefinedValues?.sharedCapital,
    vatNo: predefinedValues?.vatNo || '',
  }
}
